import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAnalytics, trackVisit, trackClick } from "./analyticsThunks";
import { AnalyticsState, ButtonClicks } from './analytics';

const initialState: AnalyticsState = {
  totalVisitors: 0,
  visitors: [],
  clickHistory: {},
  buttonClicks: {
    saveContact: 0,
    call: 0,
    whatsapp: 0,
    instagram: 0,
    email: 0,
    location: 0,
    website: 0,
    linkedin: 0,
    facebook: 0,
    twitter: 0,
    telegram: 0,
    tiktok: 0,
    youtube: 0,
    viber: 0,
    tripadvisor: 0,
    booking: 0,
  },
  lastVisitorDate: '',
  loading: false,
  success: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    resetAnalytics: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Analytics
      .addCase(fetchAnalytics.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.totalVisitors = action.payload.totalVisitors;
        state.clickHistory = action.payload.clickHistory;
        state.buttonClicks = action.payload.buttonClicks;
        state.visitors = action.payload.visitors;
        state.lastVisitorDate = action.payload.lastVisitorDate;
        state.success = true;
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.error.message || 'Failed to fetch analytics';
      })
      // Track Visit
      .addCase(trackVisit.fulfilled, (state) => {
        state.totalVisitors += 1;
        state.lastVisitorDate = new Date().toISOString();
      })
      // Track Click
      .addCase(trackClick.fulfilled, (state, action) => {
        const buttonType = action.meta.arg.buttonType as keyof ButtonClicks;
        if (state.buttonClicks[buttonType] !== undefined) {
          state.buttonClicks[buttonType] += 1;
        }
      });
  },
});

export const { resetAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;